var ProductType = /* @__PURE__ */ ((ProductType2) => {
  ProductType2["Frames"] = "frames";
  ProductType2["Accessories"] = "accessories";
  ProductType2["ContactLenses"] = "contact-lenses";
  ProductType2["Solutions"] = "solutions";
  ProductType2["Sunglasses"] = "sunglasses";
  ProductType2["ReadyReaders"] = "ready-readers";
  return ProductType2;
})(ProductType || {});
export {
  ProductType
};
//# sourceMappingURL=product-page.js.map
